import { useState } from "react";
import "./Actions.css";
import ConfirmModal from "./ConfirmModal";
import { FaArrowUp } from "react-icons/fa";

export default function Actions({
  cart = {},
  itemCount = 0,
  onClear,
  onCheckout,
  onOpenCart,
  setCart,
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // ✅ SINGLE SOURCE OF TRUTH
  const hasItems = Object.keys(cart).length > 0;

  if (!hasItems) return null;

  const handleClearClick = () => setIsModalOpen(true);
  const handleCancel = () => setIsModalOpen(false);

  const handleConfirm = () => {
    onClear?.();
    setCart({});
    localStorage.removeItem("localCart");
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="actions-bar">
        {/* Cart summary */}
        <div className="cart-info" onClick={onOpenCart}>
          <span className="cart-text">CART</span>
          <span className="cart-count">
            {itemCount} ITEMS
            <FaArrowUp className="up-arrow-icon" />
          </span>
        </div>

        {/* Actions */}
        <div className="action-right">
          <button className="clear-btn" onClick={handleClearClick}>
            Clear Cart
          </button>

          <button className="checkout-btn" onClick={onCheckout}>
            Checkout →
          </button>
        </div>
      </div>

      <ConfirmModal
        isOpen={isModalOpen}
        title="Clear your cart?"
        message="This will remove all items you've added."
        onConfirm={handleConfirm}
        onCancel={handleCancel}
      />
    </>
  );
}
